import {
  IAction,
  IAdvancedFormConfig,
  IAdvancedFormSection,
} from '~shared/modules/advanced-form/models/advanced-form.model';
import { FIELD_TYPES } from '~shared/modules/advanced-form/constants/field-types.constant';
import { VALIDATION_RULES } from '~shared/constants';
import { IAdvancedFormField } from '~shared/modules/advanced-form/models/advanced-form-fields.model';
import { FORM_SECTION_LIST_WITH_EMAIL_VARIANT } from '~app/modules/authorization/constants/validate-email.constant';

const INPUT_EDIT_LINK: IAdvancedFormField[] = [
  {
    name: 'editInput',
    label: 'EMAIL.EDIT_LINK',
    type: FIELD_TYPES.link,
    hasRequiredMark: false,
  },
];

const FORM_SECTION_LIST: IAdvancedFormSection[] = [
  {
    fieldList: [
      ...INPUT_EDIT_LINK,
      // eslint-disable-next-line no-magic-numbers
      ...FORM_SECTION_LIST_WITH_EMAIL_VARIANT[0].fieldList,
      {
        name: 'password',
        label: 'REGULAR.FIELDS.PASSWORD.LABEL',
        placeholder: 'REGULAR.FIELDS.PASSWORD.PLACEHOLDER',
        type: FIELD_TYPES.password,
        isVisiblePasswordStrengthVisualiser: true,
        hasRequiredMark: true,
      },
    ],
  },
  {
    customTagList: [
      {
        text: 'PAGES.AUTH.REGISTER.HAVE_BUSINESS',
        name: 'question',
        class: 'idam-register__have-business',
        type: 'text',
      },
      {
        text: 'PAGES.AUTH.REGISTER.HAVE_BUSINESS_TOOLTIP',
        name: 'tooltip',
        class: 'idam-register__have-business-tooltip',
        type: 'tooltip',
      },
      {
        text: 'PAGES.AUTH.REGISTER.HAVE_BUSINESS_CTA',
        name: 'call-to-action',
        class: 'idam-register__have-business-cta',
        type: 'text',
      },
    ],
    fieldList: [
      {
        name: 'registerBusiness',
        label: 'PAGES.AUTH.REGISTER.CREATE_BUSINESS',
        type: FIELD_TYPES.checkbox,
        hasRequiredMark: false,
      },
    ],
  },
];

const ACTION_LIST: IAction[] = [
  {
    type: 'submit',
    text: 'REGULAR.REGISTER',
    extras: {
      size: '',
    },
  },
];

export const ADVANCED_FORM_CONFIG: IAdvancedFormConfig = {
  validationRules: VALIDATION_RULES,
  formSectionList: FORM_SECTION_LIST,
  actionList: ACTION_LIST,
};

export const GA_TRACKING_LABEL = {
  goToLogin: 'Go to Login',
  goToPasswordReset: 'Go to Password Reset',
};
